// extracted by mini-css-extract-plugin
module.exports = {"error_message":"Edit__error_message___2RJS2","reward_distribution_table":"Edit__reward_distribution_table___2A0Ue"};